query payCyclesAccEntries(
  $first: Int
  $after: Cursor
  $filter: PayCycleFilter
  $orderBy: [PayCyclesOrderBy!]
  $searchRequest: SearchRequestInput
  $isHistorySearch: Boolean
  $isLinkSearch: Boolean
  $isSigningSearch: Boolean
) {
  payCycleSearch(
    first: $first
    after: $after
    filter: $filter
    orderBy: $orderBy
    searchRequest: $searchRequest
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    isSigningSearch: $isSigningSearch
  ) {
    nodes {
      id
      _accountingStampDate
      _accountingStampUserName
      _accountingStampTransactionReference
      _rowTimestamp
      transactionType {
        description
        layoutType
        transactionType
      }
      _isDeletable
      _isAccountingEntryStampedComplete
      paymentAccountId
      paymentAccount {
        name
        bankAccountNumber
      }
      description
      defaultPaymentDate
      controlTotalAmount
      currency {
        isoCode
      }
      _pendingApprovers
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _isTransactionCancelled
      _totalPayments
      _paymentCount
      businessUnit {
        name
      }
      corporatePeriodId
      _isStagedApprovalRequest
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
    aggregates {
      sum {
        _paymentCount
        _totalPayments
        controlTotalAmount
      }
    }
  }
}
